import React from 'react';
import classNames from "classnames";
import { connect } from '../../../../../../redux/connect';
import { getCurrentViewType, getRFIEnum } from '../../../../../../redux/selectors';
import { toOptionsArray } from "../../../../../../utils/parsing-helpers";
import { viewTypes } from "../../../../../../constants/view-types";
import PropTypes from "prop-types";
import CategoryInlineEdit from "./components/CategoryInlineEdit";
import { issueAttributesType } from "../../../../../../constants/proptype-validation";
import { ISSUE_ATTRIBUTE_NAMES } from "../../../../../../constants/issue-attribute-names";
import T from 'i18n-react';
import SingleSelectInlineEdit from "../../../../../SingleSelectInlineEdit";
import ReferenceInlineEdit from "./components/ReferenceInlineEdit";
import MultiSelectInlineEdit from "./components/MultiSelectInlineEdit";

export function PureIssuePreviewDetailsTabOtherSection({ viewType, issue, categoryOptions, priorityOptions, disciplineOptions }) {
  const divClassNames = classNames('IssuePreviewDetailsTabOtherSection', {
    'IssuePreviewDetailsTabOtherSection__narrow': viewType === viewTypes.DOCUMENT,
    'IssuePreviewDetailsTabOtherSection__wide': viewType === viewTypes.PROJECT,
  });
  return <form className={divClassNames}>
    <SingleSelectInlineEdit issue={issue} attributeName={ISSUE_ATTRIBUTE_NAMES.PRIORITY} label={T.translate('new.priority')} options={priorityOptions} horizontalAlign={true} />
    <MultiSelectInlineEdit issue={issue} attributeName={ISSUE_ATTRIBUTE_NAMES.DISCIPLINE} label={T.translate('new.discipline')} options={disciplineOptions} horizontalAlign={true} />
    <CategoryInlineEdit issue={issue} label={T.translate('new.category')} categories={categoryOptions} />
    <ReferenceInlineEdit issue={issue} />
  </form>;
}

PureIssuePreviewDetailsTabOtherSection.displayName = 'IssuePreviewDetailsTabOtherSection';

PureIssuePreviewDetailsTabOtherSection.propTypes = {
  issue: issueAttributesType.isRequired,
  viewType: PropTypes.string.isRequired,
  disciplineOptions: PropTypes.array.isRequired,
  categoryOptions: PropTypes.array.isRequired,
  priorityOptions: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
  viewType: getCurrentViewType(state),
  categoryOptions: toOptionsArray(getRFIEnum('category')(state)),
  disciplineOptions: toOptionsArray(getRFIEnum('discipline')(state)),
  priorityOptions: toOptionsArray(getRFIEnum('priority')(state)),
});

export default connect(mapStateToProps)(PureIssuePreviewDetailsTabOtherSection);

